<template>
  <div class="newsList">
    <div style="display: flex;align-items: center;justify-content: space-between;">
      <p class="pageTitle">{{isEdit?'修改':'添加'}}广告</p>
      <Button class="greenBtn" shape="circle" to="/admin_system/ad/list">返回列表</Button>
    </div>
    <div class="pageContent">
      <Form :model="form" ref="newsForm" label-position="left" :label-width="100">
        <Row :gutter="20">
          <Col span="7">
            <FormItem label="广告类型" prop="type">
              <Select v-model="form.type" clearable>
                <Option value="1">图片新闻</Option>
                <Option value="2">中部长图</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Col span="24">
          <FormItem label="广告封面" prop="cover">
            <div style="display: flex;align-items: center;">
              <div style="width: 80px;height: 80px;background-color: #ddd;display: flex;align-items: center;justify-content: center;">
                <img v-if="form.cover" style="max-width: 80px;max-height: 80px;" :src="getImageUrl(form.cover)" alt="">
              </div>
              <CutUpload btnName="封面" @AfterCut="setCover" applyType="AD" style="margin-left: 20px;"></CutUpload>
            </div>
          </FormItem>
        </Col>
        <Col span="14">
          <FormItem label="跳转链接" prop="content">
            <Input v-model="form.url" clearable></Input>
          </FormItem>
        </Col>
        <div class="btnWrap">
          <Button class="defaultBtn" type="primary" :loading="submitting" @click="submit">提交</Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
  import AdService from "@/api/ad";
  import CutUpload from '@/components/upload/CutUpload.vue'

  export default {
    components: {CutUpload},
    data() {
      return {
        form: {type: "1"},
        submitting: false,
        isEdit: false
      };
    },
    mounted() {
      let id = this.$route.query.id;
      if (id) {
        this.isEdit = true;
        this.getInfo(id);
      }
    },
    methods: {
      setCover(file) {
        this.form.cover = file.path;
        this.$forceUpdate();
      },
      // 提交
      submit() {
        if (!this.form.cover) {
          this.$Message.warning("请上传广告封面图")
          return
        }
        this.submitting = true;
        AdService.updateAd(this.form)
            .then(res => {
              if (res.errorNo == 0) {
                let text = "",
                    _this = this;
                if (this.form.id) {
                  text = "修改成功！点击确认按钮将跳转到列表页。";
                } else {
                  text = "发布成功！点击确认按钮将跳转到列表页。";
                }
                this.$Modal.confirm({
                  title: "提示",
                  content: text,
                  onOk: function () {
                    _this.$router.push("/admin_system/ad/list");
                  },
                  onCancel: function () {

                  }
                });
              } else {
                this.$Message.error(res.errorMessage);
              }
              this.submitting = false;
            })
            .catch(() => {
              this.$Message.error("连接服务器失败，请稍后再试");
              this.submitting = false;
            });
      },
      // 获取列表
      getInfo(id) {
        AdService.getAd({id})
            .then(res => {
              if (res.errorNo == 0) {
                this.form = res.data;
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch((error) => {
              console.info(error)
              this.$Message.error("连接服务器失败，请稍后再试");
            });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .newsList {
    position: relative;

    .uploadBtn {
      background: #277a44;
      color: #ffffff;
      margin-right: 10px;
    }

    .imgItem {
      position: relative;
      top: 0;
      width: 80px;
      height: 80px;
      display: inline-block;
      margin: 10px 10px 0 0;
      background: rgba($color: #000000, $alpha: 0.1);
      vertical-align: top;

      .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .btnWrap {
      text-align: center;
      padding: 30px 0;
    }
  }
</style>